export const DECISION_TYPE = {
  hit: 0,
  stand: 1,
  double: 2,
  split: 3,
  surrender: 4,
};

export const DECISION_NAME_BY_TYPE = {
  0: '',
  1: '',
  2: '',
  3: '',
  4: '',
};

export const DECISION_TYPE_RESULT = {
  0: 'HitResult',
  1: 'StandResult',
  2: 'DoubleResult',
  3: 'SplitResult',
  4: 'SurrenderResult',
};
